import { Card } from 'antd';
import styled from 'styled-components';

const styles = `
  .details-card {
    .details-item {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    .item-label {
      font-size: 14px;
    }

    .item-value {
      font-size: 16px;
      font-weight: 500;
    } 
  }

  .stock-adjustment-section {
      .stock-info {
        display: flex;
        flex-direction: column;
        gap: 8px;
        margin-bottom: 16px;
      }

      .stock-change-preview {
        .positive {
          color: #52c41a;
        }
        .negative {
          color: #f5222d;
        }
      }
    }

  .image-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 16px;
    margin-bottom: 24px;

    .image-item {
      position: relative;
      aspect-ratio: 1;
      height: 120px;
      border-radius: 8px;
      overflow: hidden;
      border: 1px solid #f0f0f0;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        transform: scale(1.05);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .image-actions {
        position: absolute;
        top: 8px;
        right: 8px;
        display: none;
        background: rgba(255, 255, 255, 0.9);
        border-radius: 4px;
        padding: 4px;
      }

      &:hover .image-actions {
        display: flex;
      }
    }
  }

  .carousel-item {
    height: 70vh;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }

  .carousel-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 50%;
    padding: 8px;
    
    &.prev {
      left: 16px;
    }
    
    &.next {
      right: 16px;
    }

    &:hover {
      background: white;
    }
  }

  .carousel-item {
    height: 50vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f5f5f5;

    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }

   .image-preview-modal {
    .ant-modal {
      max-width: 90vw;
      max-height: 90vh;
    }
    .ant-modal-content {
      background: transparent;
      box-shadow: none;
      overflow: hidden;
    }
    .ant-modal-close {
      top: 20px;
      right: 20px;
    }
    .ant-modal-body {
      border-radius: 8px;
      overflow: hidden;
    }
  }
`;

export const StyledCard = styled(Card)`
  ${styles}
`;

export const DocumentGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 8px;
  margin-top: 7px;
`;

export const DocumentItem = styled.div`
  position: relative;
  background: #f5f5f7;
  border-radius: 8px;
  padding: 12px 8px;
  text-align: center;
  transition: all 0.2s;

  &:hover {
    background: #e6e6e8;
    .actions {
      opacity: 1;
    }
  }

  .icon-wrapper {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
  }

  .filename {
    font-size: 12px;
    line-height: 1.2;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .actions {
    position: absolute;
    top: 4px;
    right: 4px;
    opacity: 0;
    transition: opacity 0.2s;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 4px;
    padding: 2px;
  }
`;


export const StockAdjustmentWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 16px;

  .ant-input-number {
    width: 200px;
  }
`;
